"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unreachablePlayCode = exports.assertUnreachable = void 0;
// Used for checking that switch cases are exhaustive at compile time.
// If a switch does not cover all possible cases, then _key will be something other than `never`
// and the compiler will report a type error.
function assertUnreachable(_key) {
    throw new Error("Unhandled case value ".concat(_key));
}
exports.assertUnreachable = assertUnreachable;
function unreachablePlayCode(playCode) {
    throw new Error("Unhandled case value ".concat(playCode));
}
exports.unreachablePlayCode = unreachablePlayCode;
//# sourceMappingURL=utilities.js.map